import { defineMessages } from 'react-intl';

export const messages: {
	betweenOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exactOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maximumOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimumOptions: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	requiredOption: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betweenOptions: {
		id: 'proforma-form-renderer.common.utils.validators.option.between-options',
		defaultMessage:
			'Must select between {minimum} and {maximum, plural, one {# choice} other {# choices}}.',
		description: 'Validation message for field with number of choices between a range.',
	},
	exactOptions: {
		id: 'proforma-form-renderer.common.utils.validators.option.exact-options',
		defaultMessage: 'Must select exactly {minimum, plural, one {# choice} other {# choices}}.',
		description: 'Validation message for field with exact number of choices.',
	},
	maximumOptions: {
		id: 'proforma-form-renderer.common.utils.validators.option.maximum-options',
		defaultMessage:
			'Must select less than or equal to {maximum, plural, one {# choice} other {# choices}}.',
		description: 'Validation message for field with maximum number of choices.',
	},
	minimumOptions: {
		id: 'proforma-form-renderer.common.utils.validators.option.minimum-options',
		defaultMessage:
			'Must select more than or equal to {minimum, plural, one {# choice} other {# choices}}.',
		description: 'Validation message for field with minimum number of choices.',
	},
	requiredOption: {
		id: 'proforma-form-renderer.common.utils.validators.option.required-option',
		defaultMessage: 'The ‘{label}’ choice is required.',
		description: 'Validation message for required choice field with given label.',
	},
});
